import {TestScreenType} from '@esgi/contracts/esgi/types/esgi.enums/test-screen-type';

export const TestScreenTypeMap = {
	[TestScreenType.None]: 'None',
	[TestScreenType.OneToOne]: 'OneToOne',
	[TestScreenType.SelfAssessment]: 'SelfAssessment',
};